import {useEffect} from 'react';
import _ from 'underscore';

import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import notifications from 'notifications';

import {canRequestAccess, InaccessibleInfo, requestAccess} from './RequestAccess';

/**
 * When a workspace item is inaccessible, render this to provide the user the option to request access.
 *
 * TODO: Refactor other usages of requestAccess to use this component.
 */
export default function WorkspaceItemInaccessibleGuard({
  inaccessibleInfo,
  modelType,
}: {
  inaccessibleInfo: InaccessibleInfo;
  modelType: string;
}): JSX.Element | null {
  useEffect(() => {
    if (inaccessibleInfo) {
      if (canRequestAccess(inaccessibleInfo)) {
        requestAccess(inaccessibleInfo);
      } else {
        notifications.error(FileBrowserConstants.INACCESSIBLE_MESSAGE);
      }
      // This component may be rendered in a call stack where the caller assumes that the
      // file is still open in the workspace. To avoid causing unexpected behavior / potential
      // re-entrancy issues, we defer closing the request until after the current stack has ended.
      _.defer(() => {
        FileBrowserActions.removeFromWorkspace(inaccessibleInfo.invalidId);
      });
    }
  }, [modelType, inaccessibleInfo]);

  return null;
}
